import { ShopifyDisputeStatus, ShopifyDisputeType } from '@monolog/shared/types/shopify.types';

// Shopify only blocks refunds on an "active or lost" chargeback; these two release the order again.
const REFUNDABLE_DISPUTE_STATUSES: ReadonlySet<ShopifyDisputeStatus> = new Set([
  ShopifyDisputeStatus.WON,
  ShopifyDisputeStatus.CHARGE_REFUNDED,
]);

// The customer has their money back through the dispute itself, so paying a claim on top of it pays
// twice. CHARGE_REFUNDED sits here *and* in the set above: Shopify accepts a further refund call on
// it, which is why refundability alone is not enough to decide whether we owe anything.
const CUSTOMER_ALREADY_PAID_STATUSES: ReadonlySet<ShopifyDisputeStatus> = new Set([
  ShopifyDisputeStatus.LOST,
  ShopifyDisputeStatus.ACCEPTED,
  ShopifyDisputeStatus.CHARGE_REFUNDED,
]);

export function blocksRefund(type: ShopifyDisputeType, status: ShopifyDisputeStatus): boolean {
  return type === ShopifyDisputeType.CHARGEBACK && !REFUNDABLE_DISPUTE_STATUSES.has(status);
}

/** Whether this dispute has already returned the customer's money, by any route. */
export function hasReturnedCustomerMoney(status: ShopifyDisputeStatus): boolean {
  return CUSTOMER_ALREADY_PAID_STATUSES.has(status);
}

/** Whether the outcome is still open, so nobody yet knows who keeps the money. */
export function isDisputeInFlight(status: ShopifyDisputeStatus): boolean {
  return status === ShopifyDisputeStatus.NEEDS_RESPONSE || status === ShopifyDisputeStatus.UNDER_REVIEW;
}
